import React from "react";
import StrengthsActivity from "../../StrengthsActivity";

class Page6 extends React.Component {
  state = {
    visible: true,
    selectedStrengths: [],
  };
  checkPageVisibility(pageNum) {
    if (pageNum == 6) {
      this.setState({
        visible: true,
      });
    } else {
      this.setState({
        visible: false,
      });
    }
  }

  setFinalStrengths = (strengths) => {
    this.setState({ selectedStrengths: strengths });
    this.props.updatePdf(strengths);
  };

  render() {
    return (
      <div>
        {this.state.visible ? (
          <StrengthsActivity
            onFinishingActivity={this.setFinalStrengths}
            alreadySelectedStrengths={this.state.selectedStrengths}
          />
        ) : (
          <div></div>
        )}
      </div>
    );
  }
}

export default Page6;
